import React from 'react';
import _ from 'lodash';
import TextField from '~/component/form/TextField'
import styled from 'styled-components';

const TargetRetiosContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  background-color: #fff;
  border-radius: 8px;
`;
const TargetRetio = styled.div`
  margin: 8px;
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  width: 80px;
`;
const TargetRetioLabel = styled.p`
  margin: 0;
  margin-right: 8px;
  font-size: 12px;
  color: #333;
`;

const TargetRetioValue = styled(TextField)`
  width: 80px;
`;

const TargetRetioNum = styled.p`
  margin: 8px 0 0;
  padding: 0;
  width: 120px;
  font-size: 12px;
  height: 1.6em;
`;

export interface DefaultOption {
  label: string
  value: {}
}

interface TargetRetiosProps {
  name: string;
  items: any[];
  value?: any;
  targetCollectionNum?: number;
}

export const TargetRetios: React.FC<TargetRetiosProps> = (props) => {

  const total = _.chain(props.value)
    .toPairs()
    .map(([_, v]) => v)
    .reject(v => !_.isNumber(v))
    .reduce(_.add)
    .value()
  const baseNam = props.targetCollectionNum! / total

  return (
    <TargetRetiosContainer>
      {props.items.map(({ key, label }) => {
        return (
          <TargetRetio key={key}>
            <TargetRetioLabel>{label}</TargetRetioLabel>
            <TargetRetioValue
              name={`${props.name}.${key}`}
              type="number"
              value={props.value![key]}
            />
            <TargetRetioNum>{(props.targetCollectionNum! && props.value![key]!) && `回答数: ${Math.ceil(baseNam * parseInt(props.value![key]!))}`}</TargetRetioNum>
          </TargetRetio>
        )
      })}
    </TargetRetiosContainer>
  );
};

export default TargetRetios